import RouteContainer from 'containers/RouteContainer';
import Component from './containers/BenefitsContainer';

export const path = `${DOCUMENTS_PATH}/benefits`;
export const navigation = { name: 'benefits', id: 'benefits.title', editTitle: 'dictionary.edit' };

export default RouteContainer(path, Component);
